import { useModal } from "@/features/modal/ModalStackManager";
import customAlert from "@/features/ui/alert/Alert";
import { BASE_URL } from "@/instance/axios";
import { Box, Button, FileInput, List, Text } from "@mantine/core";
import axios from "axios";
import { useState } from "react";

interface UploadFormProps {
  currentPath: string | undefined;
  refetch: () => void;
}

export const UploadForm = (params: UploadFormProps) => {
  const { currentPath, refetch } = params;
  const { closeModal } = useModal();
  const [filesToUpload, setFilesToUpload] = useState<File[]>([]);

  const handleUpload = async () => {
    if (!filesToUpload || filesToUpload.length === 0) return;

    for (const file of filesToUpload) {
      const formData = new FormData();
      formData.append("path", currentPath ? `${currentPath}${file.name}` : file.name);
      formData.append("file", file);

      await axios.post(`${BASE_URL}/s3/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("authToken"),
        },
      });
    }

    closeModal(null);
    refetch();
  };
  return (
    <Box w="24rem">
      {filesToUpload.length > 0 ? (
        <List size="sm" spacing="xs" mb="xs">
          {filesToUpload.map((file) => (
            <List.Item key={file.name}>{file.name}</List.Item>
          ))}
        </List>
      ) : (
        <Text size="sm" mb="xs" c="dimmed">
          선택된 파일이 없습니다.
        </Text>
      )}

      <FileInput
        label="업로드할 파일"
        multiple
        onChange={(files) => {
          const maxFileSize = 10 * 1024 * 1024; // 10MB
          const maxFileCount = 5;

          if (!files) {
            setFilesToUpload([]);
            return;
          }

          // 파일 개수 제한
          if (files.length > maxFileCount) {
            customAlert(
              `최대 ${maxFileCount}개의 파일만 업로드할 수 있습니다.`,
              "파일 업로드 제한",
              "red",
            );
            setFilesToUpload(files.slice(0, maxFileCount));
            return;
          }

          // 파일 용량 제한
          const validFiles = Array.from(files).filter((file) => {
            return file.size <= maxFileSize;
          });

          if (validFiles.length < files.length) {
            customAlert(`10MB 이하의 파일만 업로드할 수 있습니다.`, "파일 용량 제한", "red");
          }

          setFilesToUpload(validFiles);
        }}
      />

      <Button fullWidth mt="md" onClick={handleUpload}>
        업로드
      </Button>
    </Box>
  );
};
